/** server/utils/ownRecordDelete.js ile aynı sahiplik kuralı. */

export function isGeneralYetkili(user) {
  if (!user) return false;
  // Kullanıcı kartındaki İşlem (KUL_YS) ve Genel Yetkili dışındaki Yetki değerleri yetki vermez.
  // Yetki = Genel Yetkili veya admin işareti yönetici sayılır. Ekran hakları rol tanımındadır.
  return Number(user.KUL_YETKI ?? user.yetki ?? 1) === 0
    || user.KUL_ISADMIN === true
    || user.isadmin === true;
}

export function canDeleteByOwner(actor, ownerRef) {
  if (isGeneralYetkili(actor)) return true;
  const actorRef = Number(actor?.KUL_REF ?? actor?.kulRef ?? 0);
  const owner = Number(ownerRef ?? 0);
  return actorRef > 0 && owner > 0 && actorRef === owner;
}

function firstPositive(row, keys) {
  if (!row) return 0;
  for (const key of keys) {
    const value = Number(row[key] ?? 0);
    if (value > 0) return value;
  }
  return 0;
}

export function cariDataSahibiRef(row) {
  return firstPositive(row, ['CAR_ARA_KUL_REF', 'car_ara_kul_ref', 'CAR_GIR_KUL_REF', 'car_gir_kul_ref']);
}

export function aramaArayanRef(row) {
  return firstPositive(row, ['CD_YETK_REF', 'cd_yetk_ref']);
}

export function tahsilatIsYapanRef(row) {
  return firstPositive(row, ['CP_MUS_TEM', 'cp_mus_tem', 'CP_GIR_KUL', 'CP_GIR_KUL_REF', 'cp_gir_kul']);
}

export function islemIsYapanRef(row) {
  return firstPositive(row, ['CI_UPD_KUL', 'ci_upd_kul', 'CI_GIR_KUL', 'ci_gir_kul']);
}

export function ekimIsYapanRef(row) {
  return firstPositive(row, ['CE_YAP_KUL', 'ce_yap_kul', 'CE_GIR_KUL', 'ce_gir_kul']);
}

export function resimIsYapanRef(row) {
  return firstPositive(row, ['CR_GIR_KUL', 'cr_gir_kul']);
}

export function satisIsYapanRef(row) {
  return firstPositive(row, ['CAS_GIR_KUL', 'cas_gir_kul']);
}

export const FOREIGN_DELETE_MESSAGE = 'Başkasının kaydını yalnız yönetici veya admin silebilir, pasifleyebilir ve düzenleyebilir.';

export function grantMissingScreenDelete(screens) {
  if (!Array.isArray(screens)) return screens;
  return screens.map((row) => {
    if (!row || row.SIL === true) return row;
    const canUse = row.GOR === true || row.EKLE === true || row.DUZELT === true;
    if (!canUse) return row;
    return { ...row, SIL: true };
  });
}
